<template>
  <button type="button" :class="btnClass" @click="showRedirectUriModal">
    {{ i18n('Add New') }}
  </button>

  <RedirectUriModal ref="RedirectUriModal" @created="$emit('created', $event)" :application="application" />
</template>
<script>
import RedirectUriModal from "@/components/redirectUri/RedirectUriModal.vue";

export default {
  components: {
    RedirectUriModal,
  },
  props: {
    application: {
      type: Object,
      required: true,
    },
    btnClass: {
      type: String,
      default: 'btn btn-outline-light',
    },
  },
  data() {
    return {
      formData: {},
    };
  },
  emits: [
    'added',
    'created'
  ],
  methods: {
    showRedirectUriModal() {
      this.$refs['RedirectUriModal'].show();
    },
  }
};
</script>